import { BaseOwnerEntity } from "../../entity/baseOwnerEntity";

export class OrderEntity extends BaseOwnerEntity {
  id?: number;
  storeId: number;
  orderCode?: string;
  customerId?: number;
  saleChannelId?: number;
  totalPrice?: number;
  totalDiscountPrice?: number;
  totalNetPrice?: number;
  discountPercentage?: number;
  isPickup?: boolean;
  isDelivery?: boolean;
  pickupAddressId?: number;
  deliveryAddressId?: number;
  notes?: string;
  deliveryDate?: Date | null;
  deliveryAdditionHour?: number;
  serviceCarSawDate?: Date;
  pickupDate?: Date;
  pickupAdditionHour?: number;
  pickedUpDate?: Date;
  preparedDate?: Date;
  deliveredDate?: Date | null;
  pickedUpUser?: number;
  preparedUser?: number;
  deliveringUser?: number;
  dispatchStatusId?: number;
  dispatchDate?: Date;
  orderStatusId: number;
  isReceiptPrinted?: boolean;
  serviceCarId?: number;
  orderCancelReason?: string;
  deliveredNotes?: string;
  isDemandForDeliver?: boolean;
  campaignId?: number;
  campaignCode?: string;
  billingId?: number;
  currencyId?: number;
  externalOrderId?: string;
  stockTrackingDate?: Date;
  stockTrackingUser?: number;
  tags?: string;
  hangerNumber?: string;
  screenOrderNo?: number;
  serviceFee?: number;
  hangerPrice?: number;
  isServiceFeeCustom?: boolean;
  storageCost?: number;
  isStorageCostCustom?: boolean;
  finalTotalPrice?: number;
  bankCommissionAmount?: number;
  salesEmployeeId?: number;
  isComissionCalculated?: boolean;
  additionalDiscount?: number;
  isCheckedForBilling?: boolean;
  completedDate?: Date;
  completedUser?: number;
  currencyCode?: string;
  currencyRate?: number;
  currencyDate?: Date;
  shipmentNote?: string;
  shipmentPaymentOption?: string;
  paymentOption?: string;
  pickupSlotId?: number;
  deliverySlotId?: number;
}